	<div class="w-full flex flex-wrap md:grid md:grid-cols-3 gap-3 text-center text-xs md:text-sm  place-content-center ">
		<div class="rounded-md p-3 flex flex-col gap-2 justify-center items-center ">
			<img class="h-[90px] md:h-[130px] object-contain" src="/assets/img/artisan-flow/carbon-af.png" alt="Carbon offset" >
			<span class="subscribers-odometer carbon">+</span>
			<p class="font-bold">Kilograms of <br/>Carbon Offset</p>
		</div>
		<div class="rounded-md p-3 flex flex-col gap-2 justify-center items-center ">
			<img class="h-[90px] md:h-[130px] object-contain" src="/assets/img/artisan-flow/artisan-hour-af.png" alt="Hours of artisan work" >
			<span class="subscribers-odometer work">+</span>
			<p class="font-bold">Hours of Work of <br/>500+ Artisans</p>
		</div>
		<div class="w-full md:w-auto rounded-md p-3 flex flex-col gap-2 justify-center items-center ">
			<img class="h-[90px] md:h-[130px] object-contain" src="assets/img/artisan-flow/water-saving-af.png" alt="Litres of water savings" >
			<span class="subscribers-odometer water">+</span>
			<p class="font-bold">Litres of Water <br/>Savings</p>
		</div>
	</div>
